// src/pages/Support.js
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import "./Support.css";

const LOGO_DARK =
  "https://yptraining.romancontrols.com/images/romanworks-trans-white.png";
const LOGO_LIGHT =
  "https://yptraining.romancontrols.com/images/romanworks-trans-black.png";

const Support = () => {
  const [logoSrc, setLogoSrc] = useState("");

  useEffect(() => {
    document.title = "Support — Romanworks Real-Time Device Management";

    const savedTheme = localStorage.getItem("theme") || "dark-mode";
    document.body.className = savedTheme === "light-mode" ? "light-mode" : "";

    setLogoSrc(savedTheme === "light-mode" ? LOGO_LIGHT : LOGO_DARK);
  }, []);

  return (
    <div className="support-page">
      {/* Nav */}
      <nav className="support-nav">
        <div className="support-nav-inner">
          {logoSrc && (
            <img src={logoSrc} alt="Romanworks" className="support-nav-logo" />
          )}
          <div className="support-nav-links">
            <Link to="/welcome" className="support-nav-link">
              About
            </Link>
            <Link to="/login" className="support-nav-cta">
              Sign In
            </Link>
          </div>
        </div>
      </nav>

      {/* Main */}
      <main className="support-main">
        <div className="support-container">
          {/* Header */}
          <div className="support-header">
            <div className="support-header-icon">🛟</div>
            <h1 className="support-heading">Developer Support</h1>
            <p className="support-sub">
              Romanworks is built on{" "}
              <a
                href="https://developers.yonomi.cloud/getting-started/introduction"
                target="_blank"
                rel="noopener noreferrer"
                className="support-inline-link"
              >
                Allegion's Yonomi platform
              </a>
              . For technical issues, integration questions, or account
              assistance, reach out to Allegion Developer Support.
            </p>
          </div>

          {/* Card */}
          <div className="support-card">
            <div className="support-card-section">
              <h2 className="support-card-heading">
                Allegion Developer Support
              </h2>
              <p className="support-card-body">
                The Allegion Developer Support team handles inquiries related to
                the{" "}
                <a
                  href="https://developers.yonomi.cloud/getting-started/getting-started"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="support-inline-link"
                >
                  Yonomi Platform
                </a>
                , CLM mobile credentials, API access, and integration
                troubleshooting.
              </p>
            </div>

            <div className="support-divider" />

            <div className="support-card-section">
              <div className="support-resource-row">
                <span className="support-resource-label">Support Portal</span>
                <a
                  href="https://developersupport.allegion.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="support-resource-link"
                >
                  developersupport.allegion.com
                  <span className="support-external-icon">↗</span>
                </a>
              </div>

              <div className="support-resource-row">
                <span className="support-resource-label">Submit a Request</span>
                <a
                  href="https://developersupport.allegion.com/hc/en-us/requests/new"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="support-resource-link"
                >
                  Open a Support Ticket
                  <span className="support-external-icon">↗</span>
                </a>
              </div>
            </div>

            <div className="support-divider" />

            <div className="support-card-section support-ticket-action">
              <a
                href="https://developersupport.allegion.com/hc/en-us/requests/new"
                target="_blank"
                rel="noopener noreferrer"
                className="support-btn-primary"
              >
                Open a Support Ticket
              </a>
              <p className="support-ticket-note">
                Describe your issue and a support engineer will follow up with
                you by email.
              </p>
            </div>
          </div>

          {/* Back link */}
          <div className="support-back">
            <Link to="/login" className="support-back-link">
              &larr; Back to Sign In
            </Link>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="support-footer">
        <p>
          &copy; {new Date().getFullYear()} Romanworks &mdash; Powered by
          <a
            href="https://developers.yonomi.cloud/getting-started/getting-started"
            target="_blank"
            rel="noopener noreferrer"
          >
            Allegion Yonomi Platform
          </a>{" "}
          &nbsp;|&nbsp;
          <a
            href="https://realtime.romancontrols.com/privacy-policy.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          &nbsp;|&nbsp;
          <Link to="/welcome">About</Link>
        </p>
      </footer>
    </div>
  );
};

export default Support;
